import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GroupsApiService {
  constructor(private http: HttpClient) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCompanyUserGroups = (params: Record<string, any>) =>
    this.http.get<any>(`/api/v1.0/usergroup`, {
      params,
    });

  getCompanyUsersOfTheGroups = (id: string, params: Record<string, any>) =>
    this.http.get(`/api/v1.0/usergroup/${id}/users`, {
      params,
    });

  getGroupDetails = (groupId: string) => this.http.get(`/api/v1.0/usergroup/${groupId}`);

  createUserGroup = (params: Record<string, unknown>) => this.http.post('/api/v1.0/usergroup', params);

  updateUserGroup = (params: Record<string, unknown>) => this.http.put('/api/v1.0/usergroup', params);

  removeGroup = (groupId: string) => this.http.delete(`/api/v1.0/usergroup/${groupId}/remove`);

  addLabelToGroup = (req: Record<string, unknown>) => this.http.post('/api/v1.0/usergroup/labels/add', req);

  removeLabelFromGroup = (req: Record<string, unknown>) => this.http.delete('/api/v1.0/usergroup/labels/remove', { body: req });

  addUsersToGroup = (req: Record<string, unknown>) => this.http.post('/api/v1.0/usergroup/users/add', req);

  removeUsersFromGroup = (req: Record<string, unknown>) => this.http.delete('/api/v1.0/usergroup/users/remove', { body: req });
}
